import React from "react";

const AmountTransferedIcon = ({ width, height, color }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="6" fill="url(#paint0_linear_520_663)" />
      <path
        d="M27.0542 12.7973L21.5901 11.3332C21.4627 11.2991 21.3299 11.2904 21.1992 11.3076C21.0684 11.3248 20.9424 11.3676 20.8282 11.4335C20.5975 11.5667 20.4293 11.786 20.3603 12.0432C20.2914 12.3004 20.3275 12.5745 20.4606 12.8051C20.5938 13.0358 20.8131 13.204 21.0703 13.273L24.2072 14.1062L14.17 19.9012C13.9403 20.0338 13.7727 20.2522 13.704 20.5084C13.6354 20.7646 13.6713 21.0375 13.8039 21.2672C13.9365 21.4969 14.155 21.6645 14.4111 21.7331C14.6673 21.8018 14.9403 21.7658 15.17 21.6332L27.2943 14.6332C27.4648 14.5337 27.602 14.3859 27.6886 14.2084C27.7752 14.031 27.8074 13.8319 27.7811 13.6363C27.7563 13.4403 27.6741 13.256 27.5447 13.1067C27.4154 12.9574 27.2447 12.8497 27.0542 12.7973ZM24.8302 18.3653L12.7059 25.3653C12.5354 25.4648 12.3982 25.6126 12.3116 25.79C12.2249 25.9675 12.1928 26.1665 12.2191 26.3622C12.2438 26.5582 12.3261 26.7425 12.4554 26.8918C12.5848 27.0411 12.7555 27.1488 12.946 27.2012L18.4101 28.6653C18.5375 28.7 18.6704 28.7091 18.8014 28.6921C18.9323 28.6752 19.0585 28.6324 19.1729 28.5664C19.2872 28.5004 19.3873 28.4124 19.4675 28.3076C19.5476 28.2027 19.6062 28.0829 19.6398 27.9553C19.6745 27.8279 19.6837 27.6949 19.6667 27.564C19.6497 27.4331 19.607 27.3068 19.541 27.1925C19.475 27.0782 19.387 26.978 19.2821 26.8979C19.1772 26.8177 19.0575 26.7592 18.9298 26.7255L15.793 25.8923L25.8302 20.0973C26.0599 19.9647 26.2275 19.7463 26.2961 19.4901C26.3648 19.2339 26.3288 18.961 26.1962 18.7313C26.0636 18.5016 25.8452 18.334 25.589 18.2654C25.3329 18.1967 25.0599 18.2327 24.8302 18.3653Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_520_663"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#92E7BF" />
          <stop offset="1" stopColor="#39B67B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AmountTransferedIcon;
